<template>

    <div>
        <loading />
        <header-cna />
        <router-view />
        <footer-cna />
    </div>

</template>
<script>

    import footerCna from '@/template/footer'
    import headerCna from '@/template/header'
    import auth from '@/common/auth'
    import loading from '@/common/components/loading'
    import { Api } from '@/common/api'

    import pessoaHub from '@/common/pessoa-hub'

    export default {
        name: "Template",
        components: { footerCna, headerCna, loading },
        data() {
            return {

            };
        },
        watch: {
            '$route'(to) {
                this.getImagemBackground(to.path);
            }
        },
        methods: {
            getImagemBackground(path) {

                new Api("banner").get({ urlPagina: path, background: true, ativo: true, pageSize: 1 }).then(data => {
                    if (data.dataList && data.dataList.length > 0) {
                        var _data = data.dataList[0];
                        if (_data.urlImagem) {
                            $('body').css('background-image', 'url(' + _data.urlImagem + ')');
                            return;
                        }
                    }

                    $('body').css('background-image', 'url("/img/bg-traco.png")');
                    $('body').css( 'background-position-y', '50px');
                    

                }, () => { })
            },
        },
        mounted() {

            this.getImagemBackground(window.location.pathname);

            pessoaHub.start();

            var _user = auth.currentUser();
            if (_user) {
                auth.updatePessoaCna(_user.pessoaCNAId, () => {
                    this.$eventHub.$emit('user-atualizado')
                })
            }
        },
        beforeDestroy() {

        },
    };
</script>
